/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SurveySeasonSummarySurvey } from './SurveySeasonSummarySurvey';

export type SurveySeasonSummaryGroup = {
    key: SurveySeasonSummaryGroup.key;
    surveys: Array<SurveySeasonSummarySurvey>;
};

export namespace SurveySeasonSummaryGroup {

    export enum key {
        NEW_THIS_PLAN = 'newThisPlan',
        CONTINUING_FROM_LAST_YEAR = 'continuingFromLastYear',
        NOT_INCLUDED_IN_THIS_PLAN = 'notIncludedInThisPlan',
    }


}

